import script from "./SelectCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./SelectCheckbox.vue?vue&type=style&index=0&id=c52320c0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c52320c0"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
